'use client';

import { LabelProviderCore, labelProviderCoreTag } from '@ni/nimble-components/dist/esm/label-provider/core';
import { wrap } from '../../utilities/react-wrapper';

export { labelProviderCoreTag };
export { type LabelProviderCore };
export const NimbleLabelProviderCore = wrap(LabelProviderCore);
